module.exports = __webpack_public_path__ + "img/Charleston-fishing-charters-01.dd2c3f17.png";